var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-area"},[_c('el-cascader',{ref:"SelectArea",attrs:{"props":_vm.cascaderProp,"size":_vm.size,"filterable":true},on:{"change":_vm.onChange},model:{value:(_vm.cascaderValue),callback:function ($$v) {_vm.cascaderValue=$$v},expression:"cascaderValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }